import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 5, 2026</p>

        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect information that you provide directly to us, including:</p>
          <ul>
            <li><strong>Account Information:</strong> Name, email address, and phone number when you create an account</li>
            <li><strong>Contact Information:</strong> Information you provide when contacting our customer service or repair services</li>
            <li><strong>Custom Design Data:</strong> Design preferences and specifications when using our Custom Studio feature</li>
            <li><strong>Product Display Preferences:</strong> Information about products you view and save for future reference</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Display our product catalog and furniture collections</li>
            <li>Provide information about our products and services</li>
            <li>Communicate with you about product inquiries and services</li>
            <li>Provide customer support and respond to your inquiries</li>
            <li>Improve our products, services, and website functionality</li>
            <li>Send you promotional materials and updates (with your consent)</li>
            <li>Detect and prevent fraud and abuse</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Information Sharing and Disclosure</h2>
          <p>We do not sell your personal information. We may share your information with:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third-party companies that help us operate our business (cloud storage providers, email service providers)</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Storage and Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal information. Your data is stored securely using industry-standard encryption and security protocols. However, no method of transmission over the Internet is 100% secure.</p>
        </section>

        <section>
          <h2>5. Cookies and Tracking Technologies</h2>
          <p>We use cookies and similar tracking technologies to:</p>
          <ul>
            <li>Remember your preferences and settings</li>
            <li>Analyze site traffic and usage patterns</li>
            <li>Provide personalized content and advertisements</li>
          </ul>
          <p>You can control cookie settings through your browser preferences.</p>
        </section>

        <section>
          <h2>6. Your Rights and Choices</h2>
          <p>You have the right to:</p>
          <ul>
            <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
            <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
            <li><strong>Deletion:</strong> Request deletion of your personal information</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time</li>
            <li><strong>Data Portability:</strong> Request a copy of your data in a portable format</li>
          </ul>
        </section>

        <section>
          <h2>7. Children's Privacy</h2>
          <p>Our services are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.</p>
        </section>

        <section>
          <h2>8. Third-Party Links</h2>
          <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to read their privacy policies.</p>
        </section>

        <section>
          <h2>9. International Data Transfers</h2>
          <p>Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your information in accordance with applicable data protection laws.</p>
        </section>

        <section>
          <h2>10. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.</p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us:</p>
          <div className="contact-info">
            <p><strong>Email:</strong> alokfurnitures@gmail.com</p>
            <p><strong>Phone:</strong> +91 8533964262</p>
            <p><strong>Address:</strong> Railway Road, Aligarh (202001), Uttar Pradesh</p>
          </div>
        </section>

        <section className="consent-section">
          <h2>Your Consent</h2>
          <p>By using our website and services, you consent to the collection and use of your information as described in this Privacy Policy.</p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
